import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

import { ReferralFlowConfirm } from 'components/referral/referral-flow-confirm';
import { ReferralFlowLogin } from 'components/referral/referral-flow-login';
import { ReferralFlowProcessing } from 'components/referral/referral-flow-processing';
import { ReferralFlowRegister } from 'components/referral/referral-flow-register';
import { ReferralFlowWelcome } from 'components/referral/referral-flow-welcome';
import { useFathom, useSession, useStorage } from 'contexts';

const ReferralFlow = ({ model, open, setOpen }) => {
	const [view, setView] = useState('');
	const fathom = useFathom();
	const router = useRouter();
	const session = useSession();
	const storage = useStorage();

	// Hooks
	useEffect(() => {
		open ? setView('welcome') : setView('');
	}, [open]);

	// Methods
	const onClose = () => setOpen(!open);

	const onNext = async data => {
		if (data.status !== 'active') return router.push('/verify');
		fathom.trackEvent('Login', data);
		await session.onAuth(data);
		router.push(storage.storage?.redirect ? storage.storage?.redirect : `/`);
	};

	// Render
	const props = { model, open, setOpen, referralCode: router.query.referralCode, onClose, onView: setView };
	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form' size='sm'>
				{view === 'welcome' && <ReferralFlowWelcome {...props} onNext={onNext} />}
				{view === 'login' && <ReferralFlowLogin {...props} onNext={onNext} />}
				{view === 'register' && <ReferralFlowRegister {...props} onNext={onNext} />}
				{view === 'processing' && <ReferralFlowProcessing {...props} onNext={onNext} />}
				{view === 'confirmed' && <ReferralFlowConfirm {...props} onNext={onNext} />}
			</DialogContent>
		</Dialog>
	);
};

export { ReferralFlow };
